import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

export interface ClientState {
  name: string;
  value: string;
}

export const getClientState = async (name: string) => {
  return API.get<ResponseBaseWithData<ClientState>>(`/api/v3/users/me/client-state/${name}`);
};

export const getAllClientStates = async () => {
  return API.get<ResponseBaseWithData<{ data: ClientState[] }>>(`/api/v3/users/me/client-state`);
};

export const updateClientState = async (name: string, value: string) => {
  return API.put<ResponseBaseWithData<ClientState>>(`/api/v3/users/me/client-state/${name}`, {
    data: { value },
  });
};

export const deleteClientState = async (name: string) => {
  return API.delete<ResponseBaseWithData>(`/api/v3/users/me/client-state/${name}`);
};
